import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { CookieService } from "ngx-cookie-service";
import { resolve, reject } from 'q';

import { environment } from "../../environments/environment";
// import { AlertService } from './alert.service';

@Injectable()
export class AuthenticationService {
    public token: any;

    constructor(private http: HttpClient, private cookieService: CookieService) { };

    public checkAuthentication() {
        let authorized = {authorized: false, token: ''};

        if(this.cookieService.get('incontrol')) {
            authorized = { authorized: true, token: this.cookieService.get('incontrol') }
        } else if(localStorage.getItem('incontrol._access_token')) {
            authorized = { authorized: true, token: localStorage.getItem('incontrol._access_token') };
        } else if(localStorage.getItem('incontrol.anon_token')) {
            authorized = { authorized: false, token: localStorage.getItem('incontrol.anon_token') };
        } else {
            authorized = { authorized: false, token: 'incontrol' };
        }
        return authorized;
    } // checkAuthentication end

    public login(credentials) {
        const loginObservable = new Observable(observer => {
            this.http.post(`${environment.API_HOST}/login`,JSON.stringify(credentials))
            .subscribe(response => {
                this.token = response;
                // login successful if there's a jwt token in the response
                if (this.token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('incontrol._access_token', this.token.token);
                    this.cookieService.set('incontrol', this.token.token, this.token.expires_in/60/60/24, '/');
                    resolve(this.token);
                }
                observer.next(response);
                observer.complete();
            }, error => {
                observer.error(error);
                observer.complete();
            })
        });
        return loginObservable;
    } // login
    public register(credentials) {
        const loginObservable = new Observable(observer => {
            this.http.post(`${environment.API_HOST}/seller`,JSON.stringify(credentials))
            .subscribe(response => {
                if(response && response[0] && response[0].message){
                    observer.error(response);
                    observer.complete();
                }else{
                    this.token = response;
                    // login successful if there's a jwt token in the response
                    if (this.token) {
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        localStorage.setItem('incontrol._access_token', this.token.access_token);
                        this.cookieService.set('incontrol', this.token.access_token, this.token.expires_in/100, '/', 'localhost');
                        resolve(this.token);
                    }
                    observer.next(response);
                    observer.complete();
                }
            }, error => {
                observer.error(error);
                observer.complete();
            })
        });
        return loginObservable;
    } // login

    public logout() {
        const loginObservable = new Observable(observer => {
            this.cookieService.delete('incontrol');
            localStorage.removeItem('incontrol._access_token');
            let cookieExists: boolean = this.cookieService.check('incontrol');
            if(!cookieExists){
                observer.next(false);
                observer.complete();
            }else{
                this.cookieService.delete('incontrol');
                localStorage.removeItem('incontrol._access_token');
                observer.next(false);
                observer.complete();
            }
            //localStorage.removeItem('pideloradio._access_token');
        });
        return loginObservable;
    } // logout
} // class

// Mon Apr 15 2019 13:33:13 GMT-0600
